<template>
    <div>
    <a-switch-field
      varName="passwordless_options.enabled"
      varLabel="Passwordless Enabled"
      :varRequired="true"
      :varInitial="data.passwordless_options.enabled"
      :formLayout="formLayout"
      :size="size"
      :disabled="false"
    />
    <a-switch-field
      varName="passwordless_options.email.link.enabled"
      varLabel="Using Email Link"
      :varRequired="true"
      :varInitial="data.passwordless_options.email.link.enabled"
      :formLayout="formLayout"
      :size="size"
      :disabled="false"
    />
    <a-switch-field
      varName="passwordless_options.email.code.enabled"
      varLabel="Using Email Code"
      :varRequired="true"
      :varInitial="data.passwordless_options.email.code.enabled"
      :formLayout="formLayout"
      :size="size"
      :disabled="true"
    />
    <a-switch-field
      varName="passwordless_options.sms.link.enabled"
      varLabel="Using SMS Link"
      :varRequired="true"
      :varInitial="data.passwordless_options.sms.link.enabled"
      :formLayout="formLayout"
      :size="size"
      :disabled="true"
    />
    <a-switch-field
      varName="passwordless_options.sms.code.enabled"
      varLabel="Using SMS Code"
      :varRequired="true"
      :varInitial="data.passwordless_options.sms.code.enabled"
      :formLayout="formLayout"
      :size="size"
      :disabled="true"
    />
    </div>
</template>

<script>
export default {
  props: {
    formLayout: String,
    size: String,
    data: Object
  }
}
</script>